import { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar } from '@mui/material';
// components
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import useAuth from '../../../hooks/useAuth';

import { getEmployeeById } from '../../../api/employees';
import { getHomePath } from '../../../routes/paths';
import { getSection } from '../../../utils/getSection';
import { getEmployeeProfilePicture, getStudentProfilePicture } from '../../../api/profile-picture';
import { getFileUrl } from '../../../api/file';

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const { logout, whoAmI, user } = useAuth();
  const { pathname } = useLocation()
  const [avatarSrc, setAvatarSrc] = useState()
  const profile = useMemo(() => whoAmI ?? {
    lastName: '',
    givenName: 'User',
    email: '',
  }, [whoAmI])

  const MENU_OPTIONS = useMemo(() => ([
    {
      label: 'Home',
      linkTo: getHomePath(pathname),
    },
    // {
    //   label: 'Profile',
    //   linkTo: 'profile',
    // }
  ]), [getHomePath, pathname])

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    if (whoAmI?.profilePicture) {

      const fetchThumbnail = async () => {
        const res = await getFileUrl(whoAmI?.profilePicture)
        setAvatarSrc(res.url)
      }
      fetchThumbnail()
    }
  }, [whoAmI, avatarSrc])

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        {avatarSrc ?
          <Avatar src={avatarSrc} alt={`${profile.givenName} ${profile.lastName}`} /> :
          <Avatar sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}>{profile?.lastName ? `${profile?.givenName[0]?.toUpperCase()}${profile?.lastName[0]?.toUpperCase()}` : ''}</Avatar>
        }
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" textTransform='capitalize' noWrap>
            {profile ? `${profile.givenName} ${profile.lastName}` : 'User'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {profile.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} component={Link} to={option.linkTo} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem sx={{ m: 1 }} onClick={logout}>Logout</MenuItem>
      </MenuPopover >
    </>
  );
}
